import * as angular from "angular";
import * as _ from "lodash";
import { DialogUtils } from "../../../helper/dialog.helper";
import { PermissionCheck } from "../../../shared/permission";
import { ToastUtils } from "../../../helper/toast.helper";
import { Campaign } from "../../../models/campaign.model";
import { CampaignService } from "../../../services/campaign.service";

let CampaignSubscriptionDialogComponent = {
    selector: "vcCampaignSubscriptionDialog",
    templateUrl:
        "/angular/components/admin/dialogs/campaign-subscription-dialog.component.html",
    bindings: {
        campaign: "=?",
    },
    controller: class CampaignSubscriptionDialogController {
        // * bindings for typescript compiler *
        public campaign?: Campaign;
        // ************************************

        public loading = false;

        public __env: any;
        private dialog: DialogUtils;
        private readonly $scope: any;
        private toast: ToastUtils;
        private modelsUtils: any;
        private service: CampaignService;
        private permissionProvider: PermissionCheck;
        public charges: any;
        public baseUrl: string;

        constructor(
            $scope: any,
            CampaignService: CampaignService,
            DialogUtils: DialogUtils,
            PermissionCheck: PermissionCheck,
            ToastUtils: ToastUtils,
            ModelsUtils: any,
            __app_type: string,
            __env: any
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.modelsUtils = ModelsUtils;
            this.service = CampaignService;
            this.permissionProvider = PermissionCheck;
            this.__env = __env;

            this.baseUrl = "https://dashboard.stripe.com";
            if (this.__env.deployment_type == "production") {
                this.baseUrl += "/payments/";
            } else {
                this.baseUrl += "/test/payments/";
            }
        }

        $onInit() {
            this.campaign =
                _.cloneDeep(this.campaign) ?? this.modelsUtils.campaign();

            if (this.campaign.campaignid) {
                this.service
                    .charges({
                        id: this.campaign.campaignid,
                    })
                    .then(
                        (response: object) => {
                            const json = response["data"];
                            if (json.data) {
                                this.charges = json.data;
                                angular.forEach(this.charges, (charge: any) => {
                                    charge.date_created = new Date(
                                        charge.created * 1000
                                    ).toLocaleString("default");
                                });
                            } else {
                                this.toast.error();
                                this.charges = [];
                            }
                        },
                        (error) => {
                            this.toast.error(error);
                            this.charges = [];
                        }
                    );
            }
        }

        openChargeDialog(charge: any, $event: any): void {
            this.dialog.show({
                component: "vc-campaign-charge-dialog",
                targetEvent: $event,
                scope: this.$scope,
                size: "large",
                locals: {
                    charge: charge,
                },
            });
        }

        dismiss(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("admin")
    .component(
        CampaignSubscriptionDialogComponent.selector,
        CampaignSubscriptionDialogComponent
    );
